import axios from "axios"

const paramsSerializer = (params) => {
  const Qs = require("qs")
  return Qs.stringify(params, { encode: false })
}

export const findMembersByOrganizationId = (headers, organizationId, params) => {
  return axios.get(
    `${process.env.REACT_APP_MANAGEMENT_API_URL}/organizations/${organizationId}/members`,
    {
      headers,
      params,
      paramsSerializer
    }
  )
}

export const findMembersByMyself = (headers, organizationId) => {
  return axios.get(
    `${process.env.REACT_APP_MANAGEMENT_API_URL}/organizations/${organizationId}/members/myself`,
    {
      headers
    }
  )
}

export const createMember = (headers, organizationId, data) => {
  return axios.post(
    `${process.env.REACT_APP_MANAGEMENT_API_URL}/organizations/${organizationId}/members`,
    data,
    {
      headers
    }
  )
}

export const inviteMember = (headers, organizationId, data, params) => {
  return axios.post(
    `${process.env.REACT_APP_MANAGEMENT_API_URL}/organizations/${organizationId}/invite-members?${params}`,
    data,
    {
      headers
    }
  )
}

export const updateMember = (headers, organizationId, id, data, params) => {
  return axios.patch(
    `${process.env.REACT_APP_MANAGEMENT_API_URL}/organizations/${organizationId}/members/${id}?${params}`,
    data,
    {
      headers
    }
  )
}

export const deleteMembers = (headers, organizationId, id) => {
  return axios.delete(
    `${process.env.REACT_APP_MANAGEMENT_API_URL}/organizations/${organizationId}/members?memberId=${id}`,
    {
      headers
    }
  )
}

export const deleteMemberLogin = (headers, organizationId) => {
  return axios.delete(
    `${process.env.REACT_APP_MANAGEMENT_API_URL}/organizations/${organizationId}/remove-member-login`,
    {
      headers
    }
  )
}

export const getClientMember = (headers, orgId, sub) => {
  return axios.get(
    `${process.env.REACT_APP_MANAGEMENT_API_URL}/organizations/${orgId}/find-client-member/${sub}`,
    {
      headers
    }
  )
}

export const activeAccount = (headers, id, data) => {
  return axios.post(
    `${process.env.REACT_APP_MANAGEMENT_API_URL}/active-account/${id}`,
    data,
    {
      headers
    }
  )
}

export const updateInternalOrgServices = (headers, id, params) => {
  return axios.put(
    `${process.env.REACT_APP_MANAGEMENT_API_URL}/organizations/${id}/update-services-member?${params}`,
    {},
    {
      headers
    }
  )
}

export const inviteMemberIframe = (headers, id, appId, messageId, data) => {
  return axios.put(
    `${process.env.REACT_APP_MANAGEMENT_API_URL}/integrated/organization/${id}/invite-member-to-org-iframe/${appId}/${messageId}`,
    data,
    {
      headers
    },
    { useCache: false }
  )
}

export const findByPersonId = (headers, id) => {
  return axios.get(
    `${process.env.REACT_APP_MANAGEMENT_API_URL}/member-of-org/find-by-personId/${id}`,
    {
      headers
    }
  )
}
